import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { SelfServePinResetAbstractComponent } from '../self-serve-pin-reset.abstract.component';
import { ToastTypes } from '../../../shared/services/abstract/toast.service.abstract';
import { ToastService } from '../../../shared/services/toast.service';
import { ZiroIcons } from '../../../shared/models/ziro-icons.enum';
import { Observable } from 'rxjs';
import { PinResetService } from '../../../shared/services/pin-reset.service';

@Component({
  selector: 'ziro-self-serve-vm-pin-reset',
  templateUrl: '../self-serve-pin-reset.abstract.component.html',
  standalone: false,
})
export class SelfServeVmPinResetComponent extends SelfServePinResetAbstractComponent implements OnInit, OnDestroy {
  private pinResetService = inject(PinResetService);
  private toastService = inject(ToastService);

  ziroIcons = ZiroIcons;

  constructor() {
    super();
    this.headerTranslationKey = 'tkey;self_serve.voicemail.header';
    this.headingDataAutomation = 'self-serve-user-details-voicemail-header';
  }

  resetPin = (): Observable<void> => {
    return this.pinResetService.resetVoicemailPin(this.voicemailRef, this.entity.pin, false);
  };

  onPinResetSuccess: (...args: any) => void = (...args: any) => {
    this.onPinResetSuccessBase.call(this, args);

    this.toastService.push(
      ToastTypes.SUCCESS,
      this.ziroIcons.REFRESH,
      'tkey;selfserve.user.resetpin.success.title',
      'tkey;selfserve.user.resetpin.voicemail.success.message',
    );
  };
}
